import React, { useState, useCallback } from "react";
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { View, StyleSheet, TouchableWithoutFeedback, TouchableOpacity, Platform } from "react-native";
import { Image } from "react-native-expo-image-cache";
import { Video, AVPlaybackStatus } from 'expo-av';
import { MaterialCommunityIcons, Entypo, Foundation, FontAwesome5,Ionicons, Fontisto  } from "@expo/vector-icons";
import VideoVisor from "./VideoVisor";
import * as Linking from 'expo-linking';
//import { WebView } from 'react-native-webview';
import routes from "../navigation/routes";

import Hyperlink from 'react-native-hyperlink'; // Agregado al proyecto el 22-2-2022.

import configurationPost from "../config/configurationPost";
import connectionConfig from "../config/settings";      
import Text from "./Text";
import colors from "../config/colors";
import dateNow from "../utility/dateNow";
import ChooseTypeContent from "./ChooseTypeContent";
import textStyles from "../config/textStyles";
import ImageHandlerDichapp from "../utility/ImageHandlerDichapp";
import OpenGrphStractor from "./OpenGraphStractor";
//import * as LinkPreview from "expo-link-preview";

// const webUrl = connectionConfig.imageUrl + '/seedImages/'
// var infoDocumetUri =  connectionConfig.imageUrl +'/Documents/'  
// var seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'
    var perfilUri = ''
    var webUrl = ''
    var seedVideoUri = ''
    //console.log('FeedScreen ->', connectionConfig.switchS3)
    if (connectionConfig.switchS3 === true) {
        //console.log('FeedScreen -> guarda las imagenes en un bucket de aws S3')
        perfilUri = connectionConfig.imageUrlS3
        webUrl = connectionConfig.imageUrlS3
        seedVideoUri = connectionConfig.imageUrlS3
        //debugger
    } else {
        console.log('else switchS3')
        perfilUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
        webUrl = connectionConfig.imageUrl + '/seedImages/'
        seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'
    }
var changeListing = true  // Esta variable hay que eliminarla en todo el código 10 agosto 2021
var date = dateNow()


function CardOriginComponent({ 
                type,
                title,
                seedDescription, 
                seedId,
                seedName,
                seedPhoto,
                origin,
                subTitle, 
                imageUrl, 
                onPress, 
                onPressLike,
                onPressComment, 
                onPressNumLikes, 
                thumbnailUrl,
                commentsNum,
                actionsNum,
                videoNumber,
                documentSeed,
                userId,
                foundUserChecker,
                seedDate,
                content,
                seedOrder,
                urlOG
                }) {

const video =React.useRef(null);
const [status, setStatus] = useState({});  // Hook necesario para viideos
const [ followers, setFollowers ] =  useState(0)  
const [existFollowed, setExistFollowed] = useState(false) 
const [statusFollowed, setStatusFollowed] = useState(0)
const [loading, setLoading] = useState(false);
const navigation = useNavigation();


useFocusEffect(
  useCallback(() => {
      setLoading(true)
      //transitionSeed = route.params.item.seedId
      validateFollowed()
      getSeedFollowers()
      date = dateNow()
      setLoading(false)
  }, [seedId])
);



//---------------------------------------------
//Obtiene el documento de la info
//---------------------------------------------
const retriveDoc = async () => {
  //debugger
      if(documentSeed.includes('.pdf')){    // antes era if(filtroListing.documentSeed.includes('.pdf')) pero le quité el filtroListing porque documentSeed viene por parámetro.
           //Linking.openURL(infoDocumetUri +'pdfSeeds/'+ listing.documentSeed) 
           Linking.openURL(infoDocumetUri +'pdfSeeds/'+ documentSeed) 

      } 
      if(documentSeed.includes('.png')){
          //Linking.openURL(infoDocumetUri + 'imageSeedsPng/' + listing.documentSeed)
          Linking.openURL(infoDocumetUri + 'imageSeedsPng/' + documentSeed)

      }
      if(documentSeed.includes('.jpg')){
          //Linking.openURL(infoDocumetUri + 'imageSeedsB/' + listing.documentSeed)
          Linking.openURL(infoDocumetUri + 'imageSeedsB/' + documentSeed)

      }
      if(documentSeed.includes('.xls')){
          //Linking.openURL(infoDocumetUri + 'ExcellSeeds/' + listing.documentSeed)
          Linking.openURL(infoDocumetUri + 'ExcellSeeds/' + documentSeed)
      }
      if(documentSeed.includes('.xlsx')){
          //Linking.openURL(infoDocumetUri + 'ExcellSeeds/' + listing.documentSeed)
          Linking.openURL(infoDocumetUri + 'ExcellSeeds/' + documentSeed)
      }
}


//++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// EMPIEZA SECCIÓN DE CÓDIGO SEGUIDORES DE LAS SEMILLAS
//++++++++++++++++++++++++++++++++++++++++++++++++++++++++
//---------------------------------------------------
//método para ir por el número de segidore y seguidos
//---------------------------------------------------
const getSeedFollowers = async () => {
  //debugger
     var post_values = {
         seedId :   seedId       //route.params.item.seedId
     }
   configurationPost.body = JSON.stringify(post_values)
   await fetch(connectionConfig.apiUrl+'/SelectCountSeedFollowers/', configurationPost)
   .then(response => response.json())
   .then(response => {
     //followers = response.data[0].total_siguen_a   
     setFollowers (response.data[0].total_siguen_a) //Esto lo comente el lunes 9 de agosto
     //setFollowers (response.data.total_siguen_a)  
   })
   .catch(err =>{
   console.log('Insert fixo failed :( review internet service /SelectCountSeedFollowers/', err )
   })
 }

//------------------------------------------
// Valida si el usuario ya sigue la semilla
//------------------------------------------
const validateFollowed = async () => {
  var post_values = {
    //JSON.parse(user).userId
    userId :  userId,     //JSON.parse(user).userId , 
    seedId :  seedId      //route.params.item.seedId , 
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/SelecValidateStatusSeedFollowed/', configurationPost)
  .then(response => response.json())
  .then(response => {
   // debugger
   if(response.data.length !== 0){
      if( response.data[0].followerStatus === 1 ){
        setStatusFollowed(1) 
      }
      if(response.data.length != 0){
        setExistFollowed(true)
      }
  }
  getSeedFollowers()
  })
  .catch(err =>{
    console.log('Insert fixo failed :( review internet service /SelecValidateStatusSeedFollowed/', err )
  })
}  

//---------------------------------------------
// Método para seguir a la semila encontrada
//---------------------------------------------       
const onPressFollow = async () => {
  // debugger

   validateFollowed()
   if(existFollowed ===  true){
     updateStatusExistFollowed()   // Este método es por si el usuario estaba siguiendo ya esta semilla para evitar generar un registro extra en la tabla ya que esto nos generaría un número erroneo de followers pues habría más de los que en verdad existen. 
   }else{

     var post_values = {
       userId : userId,       //JSON.parse(user).userId , 
       seedId : seedId,        //route.params.item.seedId ,
       followerStatus : 1,
       seedDateFollower : date,
     }
     configurationPost.body = JSON.stringify(post_values)
     await fetch(connectionConfig.apiUrl+'/insertSeedFollower/', configurationPost)
     .then(response => response.json())
     .then(response => {
      // debugger
      getSeedFollowers()
      setStatusFollowed(1)
     })
     .catch(err =>{
       console.log('Insert fixo failed :( review internet service /insertSeedFollower/', err )
     })     
 }
}  
 
//------------------------------------------------------------
// Hace un update al estatus si anteriormente este usuario
// ya seguía esta semilla ya que los followers se sacan
// por cuenta de registros por lo que es necesario no crear 
// registros de más para que sea confiabe la cuenta.  
//------------------------------------------------------------
const updateStatusExistFollowed = async () => {
  var post_values = {
    followerStatus : 1,
    seedDatefollower : date,
    seedId : seedId,     //route.params.item.seedId,
    userId : userId,     //JSON.parse(user).userId,      
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/updateSeedFollowedStatus/', configurationPost)
  .then(response => response.json())
  .then(response => {
   // debugger
      getSeedFollowers()
      setStatusFollowed(1) 
  })
  .catch(err =>{
    console.log('Failed :( review internet service /updateSeedFollowedStatus/', err )
  })
} 

//---------------------------------------------
//método para dejar de seguir una semilla 
//---------------------------------------------           
const onPressUnFollow = async () => {
  var post_values = {
    followerStatus : 0,
    seedDatefollower : date,
    seedId : seedId,       //route.params.item.seedId,
    userId : userId,       //JSON.parse(user).userId,      
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/updateSeedFollowedStatus/', configurationPost)
  .then(response => response.json())
  .then(response => {
   // debugger
    getSeedFollowers()
    setStatusFollowed(0)
  })
  .catch(err =>{
    console.log('Failed :( review internet service /updateSeedFollowedStatus/', err )
  })
}  

//++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// TERMINA SECCIÓN DE CÓDIGO SEGUIDORES DE LAS SEMILLAS
//++++++++++++++++++++++++++++++++++++++++++++++++++++++++


 
    return (
            
<View  style={{ flex: 1, backgroundColor: colors.fondoGeneral }}>
  {/* <View style={styles.containerIcon}> */}

            {/* <ImageHandlerDichapp
          imageUrl={seedPhoto}
          imageType="seed"
          //thumbnailUrl={thumbnailUrl}
          styleImage={
          styles.imageSeed
          }
          //resizeMode="contain"
          //onPress={onPress}
         // navigation={navigation}
          //routes={routes}
        />         */}
<View style={{flexDirection: "row",  alignItems: "baseline", zindex: 1 }}>
    <View style={{width: "100%",  marginTop: "2%", marginBottom: "1%"}}>
      {
        type === 0 ?   <Text style={styles.titleSeed} >Todo inicia con una ... Semilla </Text>:
        type === 1 ?   <Text style={styles.titleSeed} >Tipo de Acción: Brindar información </Text>:
        type === 2 ?   <Text style={styles.titleSeed} >Tipo de Acción: Aportar una Idea </Text>:
        type === 3 ?   <Text style={styles.titleSeed} >Tipo de Acción: Crea un Plan </Text>:
        type === 4 ?   <Text style={styles.titleSeed} >Tipo de Acción: Realizar una actividad </Text>:
        type === 5 ?   <Text style={styles.titleSeed} >Tipo de Acción: Atraer personas que apoyen </Text>:
        type === 6 ?   <Text style={styles.titleSeed} >Tipo de Acción: Hacer divertida la semilla </Text>:
        type === 7 ?   <Text style={styles.titleSeed} >Tipo de Acción: Ramificar </Text>:
        type === 8 ?   <Text style={styles.titleSeed} >Tipo de Acción: Requerimiento </Text>:
          <Text style={styles.titleSeed} >Tipo de Acción: Donar en especie </Text> 
          
      }
    </View> 
   
</View>   

{/* </View> */}
      <View style={ styles.seedTitle}> 

      { //pinta los titulos de las acciones
            type === 0 ?
            <>
                {/* <Text style={styles.actionName}> Semilla </Text> */}
                 <View style={styles.iconOfAction0} >
                              <FontAwesome5  
                                                      
                                name={"seedling"} 
                                color={"#8DF78D"} 
                                size={20} 
                              />
                 </View>
             
                </>
         :
            type === 1 ?
            <>
                 <View  style={styles.iconOfAction1}  >
                              <AntDesign  
                                                  
                              name={"infocirlceo"} 
                              color={colors.chakra1nar} 
                              size={18} 
                              onPress={ onPress }
                              /> 
                  </View>
                     {/* <Text style={styles.actionName}> Información </Text> */}
            </>
         :
            type === 2 ?
            <>
                  <View   style={styles.iconOfAction2} >
                              <MaterialCommunityIcons
                                                       
                                  name={"lightbulb-on-outline"} 
                                  color={colors.chakra2ama} 
                                  size={20}
                                  onPress={ onPress } 
                                />
                  </View>
                  {/* <Text style={styles.actionName}> Idea </Text>                   */}
          </>
          :
            type === 3 ?
            <>
                 <View style={styles.iconOfAction3} >
                            <Fontisto  
                                                  
                                name={"map"} 
                                color={"green"} 
                                size={16} 
                                onPress={ onPress }
                              />
                 </View>
                    {/* <Text style={styles.actionName}> Plan </Text> */}
               
            </>
          :
            type === 4 ?
            <>
                 <View  style={styles.iconOfAction4}>
                        
                            <FontAwesome5   
                                                 
                                name={"people-carry"}   //tractor people-carry
                                color={"blue"} 
                                size={15} 
                                onPress={ onPress }
                              />
                  </View>       
                    {/* <Text style={styles.actionName}> Acción </Text> */}
              </>
          :
            type === 5 ?
            <>
                 <View style={styles.iconOfAction5}>
                            <Octicons 
                                                        
                                name={"megaphone"} 
                                color={colors.chakra5vlt} 
                                size={20} 
                                onPress={ onPress }
                              />
                  </View>
                  {/* <Text style={styles.actionName}> Atraer personas </Text> */}
            </>  
          :
          type === 6 ?
          <>
               <View  style={styles.iconOfAction6}>
                            <FontAwesome5  
                                                      
                                name={"hat-wizard"} 
                                color={colors.chakra6rsa} 
                                size={18} 
                                onPress={ onPress }
                            /> 
                </View>
                  {/* <Text style={styles.actionName}> Hacer divertida la semilla </Text> */}
         </>
          :
           type === 7 ?
           <>
               <View style={styles.iconOfAction7}>
                            <Fontisto                         
                            name={"sourcetree"} 
                            color={colors.chakra7ryo} 
                            size={18} 
                          /> 
                </View>
                  {/* <Text style={styles.actionName}> Ramificar la semilla </Text> */}
            </> 
          :
          null
    }            
      <Hyperlink //linkStyle={ { color: '#2980b9', textDecorationLine: 'underline' } } 
                              linkDefault={ true }
                              >
                    <Text style={styles.titleSeedName} >{seedName}</Text>
             </Hyperlink>
                                    {
              //.............................................
              //Sección que pinta 
              //.............................................
              urlOG === null ?
                null
                : urlOG === undefined ?
                  null
                  :
                  <OpenGrphStractor url={"https://github.com"}></OpenGrphStractor>
                   //<LinkPreview link={"https://github.com"} />
            }

                    <Text style={styles.titleSeed} >Inició el:  { seedDate} </Text>
          
          {/* {
             //lógica para documentos 
                  String(documentSeed).includes('.mp4') ?
                 <Video 
                    ref = {video}
                    style = {styles.imageVideoSeed}
                    source = {{ uri: seedVideoUri + documentSeed }}
                    useNativeControls
                    resizeMode = "contain"
                    isLooping
                    onPlaybackStatusUpdate = {status => setStatus(() => status)}
                 />
                  : 
                  String(documentSeed).includes('.pdf') ?
                  <Foundation
                            onPress = { () => retriveDoc()}
                            name={"page-export-pdf"}
                            size={50}
                            color={colors.lemonGreen}
                            style={styles.icon}
                  /> 
                  : 
                  String(documentSeed).includes('.avi') ?
                  <Video
                        ref={video}
                        style  ={styles.imageVideoSeed}
                        source = {{ uri: seedVideoUri + documentSeed }}                       
                        useNativeControls
                        resizeMode="contain"
                        isLooping
                        onPlaybackStatusUpdate={status => setStatus(() => status)}
                  /> 
                  : 
                  String(documentSeed).includes('.mov') ?
                  <Video
                        ref={video}
                        style  ={styles.imageVideoSeed}
                        source = {{ uri: seedVideoUri + documentSeed }}                       
                        useNativeControls
                        resizeMode="contain"
                        isLooping
                        onPlaybackStatusUpdate={status => setStatus(() => status)}
                  /> 
                  : 
                  String(documentSeed) === '' ?
                  null
                  :
                  String(documentSeed).includes('.xls') ?
                  <MaterialCommunityIcons
                      onPress = { () => retriveDoc()}
                      name={"file-excel"}
                      size={50}
                      color={colors.lemonGreen}
                      style={styles.icon}
                  /> 
                  :
                  String(documentSeed).includes('.xlxs') ?
                  <MaterialCommunityIcons
                      onPress = { () => retriveDoc()}
                      name={"file-excel"}
                      size={50}
                      color={colors.lemonGreen}
                      style={styles.icon}
                  /> 
                  :  
                   null                 
                } */}
      {/* 1. primer View </View>  */}
      
      </View>

 {/* Aqui empieza View de Imagen y Follores */}
      <View style={styles.detailsContainerSeed}> 
          <View >
          {/* {  
              true ?  
               String(seedPhoto).includes('.mp4') ?
                 <Video 
                    ref = {video}
                    style = {styles.imageSeed}
                    source = {{ uri: seedVideoUri + seedPhoto }}
                    useNativeControls
                    resizeMode = "contain"
                    isLooping
                    onPlaybackStatusUpdate = {status => setStatus(() => status)}
                 />
                :
                String(seedPhoto).includes('.mov') ?
                <Video 
                    ref = {video}
                    style = {styles.imageSeed}
                    source = {{ uri: seedVideoUri + seedPhoto }}
                    useNativeControls
                    resizeMode = "contain"
                    isLooping
                    onPlaybackStatusUpdate = {status => setStatus(() => status)}
                />
                : 
                seedPhoto === null ?    // http://18.116.234.21:5001/seedImages/
                <View style={styles.imageMountainSeed} >
                            <Foundation 
                                        name="mountains" 
                                        size={182} 
                                        color={colors.medium} />
                </View>
                :
                String(seedPhoto).includes('.png') ?
                <Image
                    style={styles.imageSeed}
                    preview={{ uri: webUrl + seedPhoto }}
                    tint="light"
                    uri= { webUrl + seedPhoto }
                /> 
                :
                <Image
                    style={styles.imageSeed}
                    preview={{ uri: webUrl + seedPhoto }}
                    tint="light"
                    uri= { webUrl + seedPhoto }
                />   
                :  
                // Este Image que viene no lo pude quitar porque sino me da un error :(
               <Image         
               />      
          }  */}
          <ImageHandlerDichapp
          imageUrl={seedPhoto}
          imageType="seed"
          //thumbnailUrl={thumbnailUrl}
          styleImage={
          styles.imageSeed
          }
          //resizeMode="contain"
          //onPress={onPress}
         // navigation={navigation}
          //routes={routes}
         />        
          </View> 
            
             
          <View style={styles.treeFollowersIconsContainer} >
                  <View  >
                      <Text style={styles.treeSeed} numberOfLines={1} >
                          <Entypo name={"tree"}
                                      //color={colors.medium} 
                                      color={colors.green} 
                                      size={25} 
                              />                
                      </Text> 
                     <Text style={styles.numbersActionsFollowers} > { actionsNum } </Text>
                 </View>    
                 <View style={styles.treeFollowersIconsContainer} >
                              <Ionicons name={"ios-people"} 
                                        color={colors.green} 
                                        size={textStyles.sizeTree} 
                                /> 
                              <Text style={styles.numbersFollowers} > { followers } </Text>  
                 </View>
                 <View style={styles.ContainerButtonEdit}>
                   {
                     foundUserChecker === "off" ?  //true?      //route.params.foundUserChecker === "off" ?
                      <View>
                          <ChooseTypeContent style={styles.buttonComponent}
                            seedId={seedId}
                            origin={origin}
                            type={type} 
                            seedDescription={seedDescription}
                            seedName={seedName} 
                            seedPhoto={seedPhoto}
                            foundUserChecker={foundUserChecker}
                            seedDate={seedDate}
                            userId={userId}
                            content={content}
                            seedOrder={seedOrder}
                            itemsRequirements={itemsRequirements}
                            />
                      </View>
                    :
                        statusFollowed ===  1 ?
                        <TouchableOpacity
                          
                         // style={styles.textEdit}
                          onPress={ () => {
                              // if(JSON.parse(user).alias === 'notUser' ){
                                if(Platform.OS === 'web' ){
                                  // alert('notUser')
                                  navigation.navigate('ViewImage')
                              }else{
                                   onPressUnFollow()
                              }
                            }                           
                          }
                        >
                       <Text 
                       style={styles.textEdit}
                      >
                           Unfollow
                       </Text>
                       </TouchableOpacity> 
                    :
                       <TouchableOpacity  
                        //  style={styles.buttonEdit}
                          onPress={ () => {
                          // if(JSON.parse(user).alias === 'notUser' ){
                            if(Platform.OS === 'web' ){
                                navigation.navigate('ViewImage')
                            }else{
                                onPressFollow()
                            }
                          }                          
                          } 
                        >
                        <Text 
                        style={styles.textEdit}>
                          Follow
                        </Text>
                      </TouchableOpacity> 
                   }                     
                  </View>   
                    
            </View>        
      </View>
{/* Aqui termina View de imagen y followers */}

            {/* </TouchableOpacity> */}
            <View style={styles.detailsContainer}>
                <Text style={styles.seedDescription} >
                  {seedDescription}
                </Text>
               

                <View style={styles.likeAndCommentContainer5}> 
                           <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"brain"} 
                                              color={"red"} 
                                              size={30} 
                                              onPress={onPressLike}
                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de cerebros like
                                  numberOfLines={2} 
                                  onPress={onPressNumLikes}>
                                  {subTitle}
                            </Text>
                            <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"comment-text-outline"} 
                                              color={"grey"} 
                                              size={30} 
                                              onPress={onPressComment} 
                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de comments
                                  numberOfLines={1} >
                                  {commentsNum}
                            </Text>
                </View>

          </View>
      
      
    
      </View>

  );


}


const styles = StyleSheet.create({
  iconOfAction0: { 
    flexDirection: "row",
    height:35 ,   
    width:35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: "#8DF78D",    
    alignItems: "center", 
    justifyContent: "center",
   // marginBottom: "-1.2%", 
   // position:'absolute',
    zIndex: 2,
    alignSelf: "flex-end",
   marginLeft: "10%", 
    marginRight: "2%", 
   marginTop: '-8%',
   backgroundColor: "#EBAB91"  
  },
  iconOfAction1: { 
    flexDirection: "row",
    height: 35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra1nar,    
    alignItems: "center", 
    justifyContent: "center",
    //marginBottom: "-1.2%", 
    zIndex: 1,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
   // marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
  iconOfAction2: { 
    flexDirection: "row",
    height: 35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra2ama,    
    alignItems: "center", 
    justifyContent: "center",
   // marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
    marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction3: { 
    flexDirection: "row",
    height: 35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra3ver,    
    alignItems: "center", 
    justifyContent: "center",
    //marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
    marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction4: { 
    flexDirection: "row",
    height: 35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: "blue",    
    alignItems: "center", 
    justifyContent: "center",
   // marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
  //  marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction5: { 
    flexDirection: "row",
    height: 35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra5vlt,    
    alignItems: "center", 
    justifyContent: "center",
    //marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
   // marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction6: { 
    flexDirection: "row",
    height:35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra6rsa,    
    alignItems: "center", 
    justifyContent: "center",
   // marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
   // marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction7: { 
    flexDirection: "row",
    height: 35,   
    width: 35,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra7ryo,    
    alignItems: "center", 
    justifyContent: "center",
  //  marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginLeft: "2%", 
    marginRight: "2%", 
    //marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },

    // ********************* Inicia css de la semilla o accion original. **************************
    detailsContainerSeed: {     //Contenedor de primera línea botones
      flexDirection: "row",
      width: "100%",
      overflow: "hidden",
    },
    imageSeed: {
      marginTop: "3%",
      marginBottom: "1%",
      marginLeft: "2.2%",
      width: 270,
      height: 270,
      marginRight:15,//'10%',
      marginLeft:15,
      backgroundColor: colors.fondoImagenes,
     // backgroundColor: "white",
    },
    imageVideoSeed: {
      width: 270,
      height: 270,
      alignSelf: "center",
      alignItems: "center",
      marginRight:'10%'
    },
    treeFollowersIconsContainer: {
      width:'20%',
      marginTop: "1.8%",
      marginBottom: ".5%",
      marginLeft: "1%",
       alignItems: "center",
      backgroundColor: colors.fondoImagenes,
      borderRadius: 15,
    },
    treeSeed:{
      marginLeft: "1%",
      color:  "green",
      marginTop: "155%",
     },
     textFollowers: {
      color: colors.green,
      fontWeight: "900",
      marginTop: "2%",
      marginLeft: "6%",
     },
     numbersActionsFollowers: {
      color: colors.textGeneral,
      marginTop: "4%",
      marginLeft:'20%'
     },
     numbersFollowers: {
      color: colors.textGeneral,
      marginTop: "-2%",
      marginBottom: "2%",
     },
    viewDescription: {
      marginTop: "1%",
      marginLeft: "4%",
      width: "92%",
      //height: "25%", 
    }, 
    description: {
      color: colors.greyDescription,
      //fontWeight: "bold",
      fontSize: 17,
      //marginVertical: 10,
      marginRight: "2%",
      marginLeft: "2%",
      marginTop: "1%",
      textAlign: "justify",
      backgroundColor: "yellow",
    },
    seedTitle:{
      width: "97%", 
     // zIndex:1,
      //alignItems: 'center',
      backgroundColor: colors.fondoImagenes,
      borderRadius: 15,
      //marginTop: "1%",
      marginLeft: "1.5%",
      marginBottom: "1%",
      padding: 5
    },
    seedTitle1:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra1nar,
    },
    seedTitle2:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra2ama,
    },
    seedTitle3:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra3ver,
    },
    seedTitle4:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra4azu,
    },
    seedTitle5:{
      marginTop: "1%",
      width: "100%", 
     //alignItems: 'center',
      backgroundColor: colors.chakra5vlt,
    },
    seedTitle6:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra6rsa,
      //pink
    },
    seedTitle7:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra7ryo,
    },
    seedTitle8:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra8tur,
    },
    seedTitle9:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra9aur,
    },
    titleSeedName: {
      color: colors.textGeneral,
      textAlign: "justify",
      fontSize: textStyles.textLarge,
      fontWeight: textStyles.fontWeightLarge,
      marginTop: "2%",
      marginLeft: "2%",
     // marginBottom: "2%",
      width: "90%",
      zIndex: 1
    },
    titleSeed: {
      color: colors.textGeneral,
      textAlign: "justify",
      fontSize: 19,
      fontSize:textStyles.textMedium,
     // marginTop: "2%",
      marginLeft: "5%",
      width: "90%",
    },
    ContainerButtonEdit: {
      marginTop: "9%",
      height: 35,  // Esta madre la tenía en porcentaje y me estaba generando un fantasma en blanco¡¡ Recuerda no usar ningún heght en porcentaje¡¡¡¡ no mameeees 6 horas perdidas me carga la chi....
      width: "100%",
    },
    buttonEdit: {
      marginLeft: "2%",
      backgroundColor: colors.primary,
      borderRadius: 15,
      justifyContent: "center",
      alignItems: "center",
      padding: 4,
      width: "100%",
      marginRight: "5%",
    },
    buttonComponent: {
      marginTop: "5%",
      marginLeft: "2%",
      backgroundColor: colors.primary,
      borderRadius: 15,
      justifyContent: "center",
      alignItems: "center",
      padding: 4,
     // width: "100%",
      marginRight: "5%",
    },
    textEdit: {
      color: colors.white,
      fontSize: textStyles.textSmall,
      marginLeft: "10%",
      width: "80%",
      backgroundColor: colors.primary,
      borderRadius: 15,
      textAlign:'center',
      padding:1
    },
    imageMountainSeed: {
      //width: "100%",
      //height: 250,
      alignItems: "center",
      //backgroundColor: "green",
    },
  // **** Aqui termina todo el css de la semilla
  
  // **** CSS para cerebro y comments ****
  detailsContainer: {
    padding: 5,
    //backgroundColor: "green",
  },
 seedDescription: {
  width: "95%",
  textAlign: "justify",
  marginLeft: "2%",
  marginBottom: 7,
  marginTop: "1.5%",
  fontSize: 20,
},
likeAndCommentContainer5: {
  flexDirection: "row",
  width: "90%",
  height: 30,
  //marginLeft: "10%",
  marginTop: "1%",
  alignItems: "center",
  //backgroundColor: "green",
},
likeAndCommentContainer5Icons: {
  marginLeft: "20%",
  //backgroundColor: "green",
},
likeAndCommentContainer5Nums: {
  marginLeft: "10%",
  color: colors.medium,
},
containerIcon: {
  //alignSelf: "flex-start", 
 // marginRight,
//  marginTop: (windowWidth * .01),
 // backgroundColor: "red", 
  width: "100%",
  height: 40,
//  marginBottom: (windowHeight * -.012),
 // zIndex: 1,
  flexDirection: "row"
  }

});

export default CardOriginComponent;


